// extracted by mini-css-extract-plugin
module.exports = {"reportSortGroupByButton":"ReportSortGroupByButton_reportSortGroupByButton__2qDum","label":"ReportSortGroupByButton_label__30K3O","iconBtn":"ReportSortGroupByButton_iconBtn__24BNF"};